module.exports = __webpack_public_path__ + "static/media/colabs-portfolio_05.e1c2b0ea.jpg";